import{WalletCreate as i}from"@privy-io/public-api";async function r(r,{request:t}){return await r.fetchPrivyRoute(i,{body:t})}export{r as create};
